import { Component } from 'react'
import { IconSquircle } from '../../generic'
import _ from 'lodash'
import { connect } from 'react-redux'

interface CategoryItem {
  visible: boolean
  isHidden: boolean
  id: string
}

interface ModalCategoryItemSelectorProps {
  data: {
    items: {
      id: string
      icon: string
      color?: string
      name: string
      category?: string
    }[]
    categories: {
      id: string
      color: string
    }[]
  }
  setFormField: (data: { key: string; value: any }) => void
  goToNextStep?: () => void
  categoryItems: Array<CategoryItem>
}

class ModalCategoryItemSelector extends Component<ModalCategoryItemSelectorProps> {
  onSelect(itemId: string | undefined, title: string): void {
    if (itemId) this.props.setFormField({ key: 'item', value: itemId })
    this.props.setFormField({ key: 'title', value: title })
    this.props.setFormField({ key: 'description', value: null })
    if (this.props.goToNextStep) this.props.goToNextStep()
  }

  onSelectCustom = (): void => {
    this.props.setFormField({ key: 'isCustomEntry', value: true })
    this.onSelect(undefined, '')
  }

  getCategoryColor(id: string): string | undefined {
    const categoryData = _.find(this.props.data.categories, { id })
    if (categoryData) return categoryData.color
  }

  render(): JSX.Element | null {
    const {
      data: { items, categories },
      categoryItems,
    } = this.props
    if (!items || !categories) return null
    const hiddenCategoryItems = categoryItems
      .filter((item) => item?.visible !== true && item?.isHidden === true)
      .map((item) => item.id)
    const filteredItems = items.filter(
      (item) => !hiddenCategoryItems.includes(item.id)
    )
    return (
      <div style={{ margin: '20px 20px' }}>
        <h2 style={{ textAlign: 'center' }}>Choose an Item</h2>
        <div
          data-cy="log-item-container"
          style={{
            textAlign: 'center',
            width: '80%',
            margin: '40px auto 30px',
          }}
        >
          {filteredItems.map((item) => (
            <IconSquircle
              style={{ width: 110 }}
              key={item.id}
              icon={item.icon}
              color={item.color || this.getCategoryColor(item.category || '')}
              label={item.name}
              onSelect={() =>
                this.onSelect(item.id, item.name.split('/ ').slice(-1)[0])
              }
            />
          ))}
        </div>
        <div style={{ textAlign: 'center', paddingTop: 30 }}>
          <h3 style={{ cursor: 'pointer' }} onClick={this.onSelectCustom}>
            + Add Custom
          </h3>
        </div>
      </div>
    )
  }
}

interface RootState {
  data: {
    'log-category-items': Array<CategoryItem>
  }
}

const mapStateToProps = (state: RootState) => {
  return {
    categoryItems: state.data['log-category-items'] ?? [],
  }
}

export default connect(mapStateToProps)(ModalCategoryItemSelector)
